import React from "react";
import { Link } from "react-router-dom";
import styled from "styled-components";
import "./Drawer.scss";
// import logo from "../../../assets/rupali-logo.svg";
import logo from "../../../assets/rupali-logo-short.png";
import ExpandMenu from "./ExpandMenu/ExpandMenu";

const Drawer = ({ isOpen, toggleDrawer, routes }) => {
  return (
    <>
      {isOpen && <BackdropMenu onClick={toggleDrawer} />}

      <DrawerMenu isOpen={isOpen}>
        <div className="container">
          <div className="drawer_nav_menu">
            <div className="nav_logo text-center" onClick={toggleDrawer}>
              <Link to="/">
                <img src={logo} className="img-fluid w-25 d-none" alt="" />
              </Link>
            </div>

            <div className="drawer_nav_routes">
              {routes.map((route) => {
                if (route.subRoutes) {
                  return (
                    <ExpandMenu
                      route={route}
                      key={route.name}
                      toggleDrawer={toggleDrawer}
                    />
                  );
                }

                return (
                  <div
                    className="drawer_nav_route"
                    onClick={toggleDrawer}
                    key={route.name}
                  >
                    <Link to={route.link}>{route.name}</Link>
                  </div>
                );
              })}

              {/* <div>
              <button className="btn login_btn">Login</button>
            </div> */}
            </div>

            {/* <div className="d-block d-lg-none ">
              <button className="btn login_btn">Login</button>
            </div> */}
          </div>
        </div>
      </DrawerMenu>
    </>
  );
};

export default Drawer;

const BackdropMenu = styled.div`
  height: 100%;
  width: 100%;
  z-index: 150;
  position: fixed;
  top: 57px;
  left: 0;
  transition: 0.3s ease;
  background-color: rgba(0, 0, 0, 0.5);
`;

const DrawerMenu = styled.div`
  z-index: 210;
  position: fixed;
  top: 57px;
  min-height: 94vh;
  width: 290px;
  // width: 70%;
  // background-color: white;
  // background: linear-gradient(to left, #d41459, #911a6c);
  background: linear-gradient(88.32deg, #911a6c 1.87%, #eb668a 143.4%);
  color: #fff;
  transition: 0.3s ease;
  transform: translateX(${(props) => (props.isOpen ? "0" : "-100%")});
`;
